import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { DetailSection } from './DetailSection';
import { DetailField } from './DetailField';

export function OrganizationEntitlementsPanel({ org }) {
  const { t } = useTranslation();

  const fields = [
    { label: t('organizations.accessMode'), value: org.entitlements?.accessMode ?? '—' },
    { label: t('organizations.planSlug'), value: org.entitlements?.planSlug ?? '—' },
    {
      label: t('organizations.seats'),
      value: `${org.entitlements?.seatsUsed ?? 0} / ${org.entitlements?.maxSeats ?? '—'}`,
    },
    { label: t('organizations.renderCredits'), value: org.entitlements?.credits?.ai_render ?? 0 },
    { label: t('organizations.optimizationCredits'), value: org.entitlements?.credits?.cut_optimization ?? 0 },
    { label: t('organizations.members'), value: org.memberCount ?? 0 },
  ];

  return (
    <DetailSection title={t('organizations.entitlements')}>
      <Grid container spacing={{ xs: 1.5, sm: 2 }}>
        {fields.map((field) => (
          <DetailField key={field.label} label={field.label} value={field.value} />
        ))}
      </Grid>
    </DetailSection>
  );
}
